import React from 'react';

const TimelineDispenseMHRIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.74951" cy="9" r="8.5" fill="#8DBABA" />
    </svg>
  );
};

export default TimelineDispenseMHRIcon;
